module.exports = " <div id=ia-middlesmall style=\"margin-bottom: 5px\" _v-3f36baac=\"\"> <div id=ia-pgnHeader _v-3f36baac=\"\"></div> <div id=ia-pgnButtons _v-3f36baac=\"\"></div> <div id=ia-pgnError _v-3f36baac=\"\"></div> <p _v-3f36baac=\"\"></p> <div id=ia-boardsmall style=\"width:100%; height:60px\" :class=classboard _v-3f36baac=\"\"> </div> <div id=pgnMovesIA _v-3f36baac=\"\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3f36baac!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/game/boardVisorIa.vue
// module id = 504
// module chunks = 10